import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import SqftCanvasContainer from "../../../sqft/components/canvas/core/SqftCanvasContainer";
import useResetState from "../../../sqft/hocs/onLoad/useResetState";
import useUpdateSqftConfig from "../../../sqft/hocs/onLoad/useUpdateSqftConfig";
import useImportSQFTData from "../../../sqft/hocs/onLoad/useImportSQFTData";
import {setWizardConflictPopupOpened} from "../../../../actions/wizardFunctions";
import {connect} from "react-redux";
import {highlightShapes} from "../../../sqft/helpers/conflictPopupHelper";
import PropTypes from "prop-types";
import {getFeatureGroupName} from "../../../../misc/helpers";
import sqftConfig from "../../../sqft/components/canvas/store/sqftConfig";

const SQFTWindow = (props) => {
  const { wizardConflictingSteps, cartItemsToChange, visualizersLoaded, intl, fabricatorData, activeFeature } = props;
  void wizardConflictingSteps;

  useResetState();
  useUpdateSqftConfig();
  useImportSQFTData(visualizersLoaded);
  const sqftShapesIdsToRemove = [
    ...new Set(
      cartItemsToChange.flatMap(cartItem => [
        ...(cartItem.sqftIds || []),
        cartItem.sqftId
      ].filter(Boolean))
    )
  ];
  setTimeout(() => {
    sqftConfig.setScale(2);
    highlightShapes(sqftShapesIdsToRemove);
  },100);
  const firstIncompatibleSqftItem = cartItemsToChange.find(cartItem => cartItem.sqftId);
  const incompatibleFeatureName = firstIncompatibleSqftItem?.cartFeature?.getFeatureName();
  const featureGroup = firstIncompatibleSqftItem.cartFeature.getParent();
  const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
  const activeFeatureName = activeFeature?.getFeatureName();

  return (
    <>
      <p className="ui-popup__body-subtitle">
        <FormattedMessage id="confirmPopup.sqftIncompatibleText" values={
          { incompatibleFeatureName,
            featureGroupName,
            activeFeatureName
          }
        }/>
      </p>

      <div className="conflict-fix">
        <SqftCanvasContainer />
      </div>
    </>
  );
};


SQFTWindow.propTypes = {
  cartItemsToChange: PropTypes.array.isRequired,
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
    visualizersLoaded: store.serverState.visualizersLoaded,
    activeFeature: store.selectionState.activeFeature,
  };
};

const mapDispatchToProps = {
  setWizardConflictPopupOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SQFTWindow)
)

